// Custom stroke line icons keyed by service/industry id.
const PATHS = {
  shield: (
    <>
      <path d="M12 3l7 3v5c0 4.6-3 8.2-7 10-4-1.8-7-5.4-7-10V6l7-3z" />
      <path d="M9 12l2 2 4-4.5" />
    </>
  ),
  continuity: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 4v3M12 17v3M4 12h3M17 12h3" />
      <path d="M9.5 12a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0z" />
    </>
  ),
  quality: (
    <>
      <circle cx="12" cy="9" r="5.5" />
      <path d="M9 13.5L7.5 21l4.5-2.5L16.5 21 15 13.5" />
      <path d="M10 9l1.5 1.5L14.5 7" />
    </>
  ),
  governance: (
    <>
      <rect x="4" y="4" width="16" height="4" rx="1" />
      <path d="M12 8v4M6 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" />
      <rect x="3" y="16" width="6" height="4" rx="1" />
      <rect x="15" y="16" width="6" height="4" rx="1" />
    </>
  ),
  training: (
    <>
      <path d="M12 5L2 9l10 4 10-4-10-4z" />
      <path d="M6 11v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5" />
      <path d="M22 9v6" />
    </>
  ),
  assessment: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <path d="M12 12l5-5" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3" />
    </>
  ),
  remediation: (
    <>
      <path d="M14.5 6.5a4 4 0 0 0-5.6 4.9L4 16.3V20h3.7l4.9-4.9a4 4 0 0 0 4.9-5.6l-2.6 2.6-2.5-1-1-2.5 3.1-2.1z" />
    </>
  ),
  swift: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.5 2.3 3.8 5.2 3.8 8.5s-1.3 6.2-3.8 8.5c-2.5-2.3-3.8-5.2-3.8-8.5s1.3-6.2 3.8-8.5z" />
    </>
  ),
  payment: (
    <>
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3 10h18" />
      <path d="M7 15h4" />
      <path d="M15.5 14.5l1.5 1.5 3-3.5" />
    </>
  ),
  consulting: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M15.5 8.5l-2 5-5 2 2-5 5-2z" />
    </>
  ),
  development: (
    <>
      <path d="M8 6l-5 6 5 6M16 6l5 6-5 6" />
      <path d="M13.5 4l-3 16" />
    </>
  ),
  bank: (
    <>
      <path d="M3 9l9-6 9 6" />
      <path d="M4 9v10M8.5 9v10M12 9v10M15.5 9v10M20 9v10" />
      <path d="M2.5 19h19v2h-19z" />
    </>
  ),
  fintech: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M10.5 6.5h3" />
      <path d="M10 15l1.5 1.5L15 13" />
    </>
  ),
  technology: (
    <>
      <rect x="4" y="5" width="16" height="11" rx="1.5" />
      <path d="M2 19h20" />
      <path d="M9 9l-2 1.5L9 12M15 9l2 1.5L15 12" />
    </>
  ),
  telecoms: (
    <>
      <path d="M12 20h.01" />
      <path d="M8.5 16.5a5 5 0 0 1 7 0M5.5 13a9.5 9.5 0 0 1 13 0M2.5 9.5a14 14 0 0 1 19 0" />
    </>
  ),
  public: (
    <>
      <path d="M12 3l8 4v5c0 4.6-3.4 8.1-8 9-4.6-.9-8-4.4-8-9V7l8-4z" />
      <path d="M12 8v5M12 16h.01" />
    </>
  ),
  professional: (
    <>
      <rect x="4" y="7" width="16" height="13" rx="2" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M4 12h16" />
    </>
  ),
  growth: (
    <>
      <path d="M3 17l5-6 4 3 6-8 3 4" />
      <path d="M3 21h18" />
    </>
  ),
};

export default function ServiceIcon({ name, size = 24, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {PATHS[name] || PATHS.shield}
    </svg>
  );
}
